import type { Period } from '@weft/types';
import { PAYMENT_TERMS, type PaymentTerm } from '@weft/types';
import { dayjs } from '@weft/utils';

export function getIssueDay(paymentTerm: PaymentTerm, billingCycle: Period): dayjs.Dayjs {
  return paymentTerm === PAYMENT_TERMS.Postpayment ? dayjs(billingCycle.endTime) : dayjs(billingCycle.startTime);
}

export function getPaymentDueDay(paymentTerm: PaymentTerm, billingCycle: Period, paymentDueDays: number): dayjs.Dayjs {
  const issueDay = getIssueDay(paymentTerm, billingCycle);

  return issueDay.add(paymentDueDays, 'day');
}